import React, { useEffect, useState } from 'react'
import clsx from 'clsx'

import { ButtonProps } from './ButtonProps'
import './Button.scss'


export enum AppButtonTypes {
   PRIMARY = "PRIMARY",
   SECONDARY = "SECONDARY",
   OUTLINED = "OUTLINED",
}

/**
 * Bazowy komponent przycisku w aplikacji
*/
const Button = ({ onClick, className, buttonContent, uiButtonType, isLoading, ...others } : ButtonProps): JSX.Element => {

   const handleButtonOnClick = (e: React.MouseEvent<HTMLButtonElement>) => {
      if ((typeof onClick === 'function') && (isLoading === undefined || isLoading === false)) {
         onClick(e)
      }
      else {
         return
      }
   }

   return (
      <div className='page-main-button-outer-wrapper'>
         <button 
            className={clsx(
               'page-main-button', 
               className && className, 
               uiButtonType === AppButtonTypes.PRIMARY && 'page-main-button-primary', 
               uiButtonType === AppButtonTypes.SECONDARY && 'page-main-button-secondary',
               uiButtonType === AppButtonTypes.OUTLINED && 'page-main-button-outlined',
            )} 
            onClick={(e: React.MouseEvent<HTMLButtonElement>) => handleButtonOnClick(e)} 
            {...others}
         >
            {isLoading ? <span className="page-main-button-loader-spinner"></span> : buttonContent}
         </button>
      </div>
   )
}

export default Button